import PropTypes from 'prop-types';
import React from 'react';
import '../../styles/messagePane.scss';
import File from '../../svgIcons/components/file';
import Send from '../../svgIcons/components/send';
import Smiley from '../../svgIcons/components/smiley';

class MessagePaneButtons extends React.Component {

  handleFileSelect(e) {
    const file = e.target.files[0];
    if (file) {
      this.props.onFileSelect(file);
    }
  }

  render() {

    return (
      <span className="message-pane-buttons">
        {this.props.shouldShowEmojiButton ? <button className="emoji-button" onClick={this.props.handleEmojiPaneToggle}><Smiley size="18px"/></button> : null}
        {this.props.shouldShowSend ? <button className="send-button" onClick={e => this.props.handleSend(e)}><Send size="16px"/></button> :
          (
            this.props.shouldShowAttachmentButton ?
              <span className="file-button" onClick={this.props.onAttachmentClick}>
                <File size="17px"/>
                <input
                  type="file"
                  accept=".xlsx,.xls, image/*,.doc, .docx, .ppt, .pptx, .pdf"
                  onChange={e => this.handleFileSelect(e)}
                  className="file-upload-input"
                  />
              </span> : null
          )
        }
      </span>
    );
  }
}

MessagePaneButtons.propTypes = {
  handleEmojiPaneToggle: PropTypes.func,
  onAttachmentClick: PropTypes.func,
  handleSend: PropTypes.func,
  onFileSelect: PropTypes.func,
  shouldShowSend: PropTypes.bool,
  shouldShowEmojiButton: PropTypes.bool,
  shouldShowAttachmentButton: PropTypes.bool
};

export default MessagePaneButtons;



// WEBPACK FOOTER //
// ./chat-app/components/MessagePaneButtons/MessagePaneButtons.js